<template>
<!-- 排考信息管理 弹窗：批量导入排考信息 -->
    <el-dialog :title="errorList.length?errorTextConfig.title:importTextConfig.title" v-if="dialogVisible" :visible.sync="dialogVisible" :width="errorList.length?'700px':'500px'" @close="close" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-upload v-if="errorList.length == 0"
                drag action="void"
                :limit="1" multiple
                name="file"
                :file-list="fileList"
                :before-upload="beforeAvatarUpload"
                :http-request="uploadFile"
                :on-progress="progressA"
                :on-remove="handleRemove"
                :auto-upload="true"
                style="padding-bottom:20px">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text" v-html="importTextConfig.uploadText"></div>
            <div class="el-upload__tip" slot="tip" style="text-align:center">{{ importTextConfig.uploadTip }}<br /><el-button type="text" style="margin-left:20px"><a :href="config_env.BASE_URL+'/api/file/common/download?fileUri=/profile/template/arrangement.xlsx&rename=' + importTextConfig.templateName + '.xlsx'">{{ importTextConfig.download }}</a></el-button><p v-if="info" style="margin-top:8px"><i class="el-icon-warning-outline"></i> {{info}}</p></div>
        </el-upload>
        <div v-else>
            <p>{{ errorTextConfig.text }}</p>
              <el-table :data="errorList" stripe size="medium" :height="height" style="width: 100%">
                <el-table-column prop="examPlan" :label="tableTextConfig.examPlan" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="examineeName" :label="tableTextConfig.examineeName" min-width="110" show-overflow-tooltip></el-table-column>
                <el-table-column prop="admissionNo" :label="tableTextConfig.admissionNo" width="180"></el-table-column>
                <el-table-column prop="subject" :label="tableTextConfig.subject" min-width="150" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <span v-if="errorList.length" slot="footer" class="dialog-footer">
            <el-button @click="close">{{ importTextConfig.cancel }}</el-button>
            <el-button type="primary" @click="errorList = []">{{ importTextConfig.reUpload }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import request from '../../../utils/request'
export default {
    props: ['show', 'examId'],
    data() {
        return {
            dialogVisible: false,
            http: null,
            fileList:[],
            errorList: [],
            height: 200,
            info:''
        };
    },
    computed: {
        importTextConfig() {
            return this.$store.state.global.textConfig.backend.arrangement.examEdit.examinee.import
        },
        errorTextConfig() {
            return this.importTextConfig.error
        },
        tableTextConfig() {
            return this.errorTextConfig.table
        }
    },
    watch: {
        show() {
            this.dialogVisible = this.show;
        }
    },
    methods: {
        beforeAvatarUpload (file) {
            this.info = ''
            var testmsg = file.name.substring(file.name.lastIndexOf('.')+1)
            const extension = testmsg === 'xls'
            const extension2 = testmsg === 'xlsx'
            const isLt2M = file.size / 1024 / 1024 < 50
            if(!extension && !extension2) {
                this.$message({
                    message: '上传文件只能是XLSX格式!',
                    type: 'warning'
                });
            }
            if(!isLt2M) {
                this.$message({
                    message: '上传文件大小不能超过 50MB!',
                    type: 'warning'
                });
            }else {
                if (file.size>250000) {
                    this.info = '导入排考信息较多，请耐心等候页面自动跳转'
                }
            }
            return extension || extension2 && isLt2M
        },
        uploadFile (file) {
            let f = file.file
            let formData = new FormData();
            formData.append("file", f);
            this.http = request({
                url: `/api/arrangement/examinee/batch/${this.examId}`,
                method: 'post',
                data: formData,
                //上传进度
                onUploadProgress: (progressEvent) => {
                    let num = progressEvent.loaded / progressEvent.total * 100 | 0;  //百分比
                    file.onProgress({percent: num})     //进度条
                }
            }).then(res => {
                file.onSuccess(); //上传成功(打钩的小图标)
                this.info = ''
                if (res.status == 200) {
                    this.close()
                    this.$emit('close', 1)
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });
                } else {
                    if (res.errorCode === 20009) {
                        this.errorList = res.data
                    }
                }
            })
        },
        handleRemove(file) {
            this.http.abort(); //取消上传
            this.$message({message: '成功移除' + file.name, type: 'success'});
            this.errorList = []
        },
        /**     文件正在上传时的钩子    **/
        progressA(event, file) {},
        close() {
            this.dialogVisible = false
            this.errorList = []
            this.$emit('close', '')
        }
    }
};
</script>

<style>
    .el-upload, .el-upload-dragger {
        width: 100%;
    }
</style>